import React from 'react';
import PropTypes from 'prop-types';
import Dialog from '@material-ui/core/Dialog';
import { makeStyles } from '@material-ui/core/styles';
import CloseIcon from '@material-ui/icons/Close';

import Button from '$components/Button';

import {
  Header,
  TitleContainer,
  Title,
  SubTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Divider,
  Loader,
} from './Modal.styled';

const useStyles = makeStyles({
  paperFullWidth: {
    maxWidth: '456px',
    borderRadius: '4px',
    overflow: 'hidden',
  },
});

const stopPropagation = (e) => e.stopPropagation();

const Modal = ({
  headerText,
  subHeaderText,
  children,
  open,
  submitText,
  handleSubmit,
  footerDecoration,
  isDisabled,
  isLoading,
  handleClose,
}) => {
  const classes = useStyles();

  return (
    <Dialog
      onClose={handleClose}
      onClick={stopPropagation}
      open={open}
      fullWidth
      classes={{ paperFullWidth: classes.paperFullWidth }}
      disableEnforceFocus
    >
      <Header disableTypography>
        <TitleContainer>
          <Title data-testid="modal-title">{headerText}</Title>
          <IconButton
            onClick={handleClose}
            label="Close"
            size="medium"
            aria-label="close-modal"
          >
            <CloseIcon />
          </IconButton>
        </TitleContainer>
        {subHeaderText && <SubTitle>{subHeaderText}</SubTitle>}
      </Header>
      <DialogContent>{children}</DialogContent>
      {handleSubmit && (
        <>
          <Divider />
          <DialogActions hasFooterDecoration={!!footerDecoration}>
            {footerDecoration}
            {open && isLoading && <Loader size={20} />}
            {open && !isLoading && (
              <Button
                label={submitText}
                look="primary"
                onClick={handleSubmit}
                size="large"
                disabled={isDisabled}
              >
                {submitText}
              </Button>
            )}
          </DialogActions>
        </>
      )}
    </Dialog>
  );
};

Modal.propTypes = {
  children: PropTypes.node.isRequired,
  headerText: PropTypes.string,
  subHeaderText: PropTypes.string,
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func,
  submitText: PropTypes.string,
  handleSubmit: PropTypes.func,
  isDisabled: PropTypes.bool,
  footerDecoration: PropTypes.element,
  isLoading: PropTypes.bool,
};

const noop = () => {};

Modal.defaultProps = {
  headerText: '',
  subHeaderText: null,
  submitText: 'Done',
  isDisabled: false,
  handleClose: noop,
  handleSubmit: null,
  footerDecoration: null,
  isLoading: false,
};

export default Modal;
